/**
 * DUO Code Apply functionality for subscription payment page
 */

const DuoCodeApply = {
	$applyBtn: null,
	$codeInput: null,
	$discountDisplay: null,

	init() {
		this.cacheElements();

		if (!this.$applyBtn || !this.$codeInput) {
			return; // Elements not found, exit early
		}

		this.bindEvents();
	},

	cacheElements() {
		this.$applyBtn = document.getElementById('duo-code-apply-btn');
		this.$codeInput = document.getElementById('duo-code-input');
		this.$discountDisplay = document.getElementById('duo-code-discount-display');
	},

	bindEvents() {
		// Apply button click
		this.$applyBtn.addEventListener('click', (e) => {
			e.preventDefault();
			this.applyCode();
		});

		// Allow Enter key to apply
		this.$codeInput.addEventListener('keypress', (e) => {
			if (e.key === 'Enter' || e.keyCode === 13) {
				e.preventDefault();
				this.applyCode();
			}
		});
	},

	applyCode() {
		const code = this.$codeInput.value.trim();

		if (!code) {
			this.showError(wpcore.direct_t({ en: 'Please enter DUO Code', fr: 'Veuillez entrer le code DUO' }));
			return;
		}

		// Show loading state
		this.setButtonLoading(true);

		// Prepare form data
		const formData = new FormData();
		formData.append('action', 'wpcore_apply_due_code');
		formData.append('code', code);
		formData.append('nonce', wpcore_due_code.nonce);

		// Call AJAX
		fetch(wpcore_due_code.ajax_url, {
			method: 'POST',
			body: formData
		})
		.then(response => response.json())
		.then(response => {
			console.log('AJAX response:', response);
			if (response.success) {
				this.handleSuccess(response.data);
			} else {
				this.showError(response.data?.message || wpcore.direct_t({ en: 'Unable to apply DUO Code', fr: 'Impossible d\'appliquer le code DUO' }));
			}
		})
		.catch(error => {
			console.error('AJAX error:', error);
			this.showError(wpcore.direct_t({ en: 'Connection error. Please try again.', fr: 'Erreur de connexion. Veuillez réessayer.' }));
		})
		.finally(() => {
			this.setButtonLoading(false);
		});
	},

	setButtonLoading(isLoading) {
		if (isLoading) {
			this.$applyBtn.disabled = true;
			this.$applyBtn.textContent = wpcore.direct_t({ en: 'Processing...', fr: 'Traitement...' });
		} else {
			this.$applyBtn.disabled = false;
			this.$applyBtn.textContent = wpcore.direct_t({ en: 'Apply', fr: 'Appliquer' });
		}
	},

	handleSuccess(data) {
		console.log('DUO Code applied:', data);

		// Show success alert
		this.showSuccess(data.message);

		// Show the discount display div (don't override innerHTML - keep the template HTML)
		if (this.$discountDisplay) {
			this.$discountDisplay.style.display = 'block';
		}

		// Disable input and button (code already applied)
		this.$codeInput.disabled = true;
		this.$applyBtn.textContent = wpcore.direct_t({ en: 'Applied ✓', fr: 'Appliqué ✓' });
		this.$applyBtn.classList.add('applied');
		this.$applyBtn.disabled = true;

		// Store applied code in hidden field for form submission
		if (!document.getElementById('applied_due_code')) {
			const input = document.createElement('input');
			input.type = 'hidden';
			input.id = 'applied_due_code';
			input.name = 'applied_due_code';
			input.value = data.code;

			const form = document.querySelector('form');
			if (form) {
				form.appendChild(input);
			}
		}
	},

	updatePriceDisplay(data) {
		// This function is no longer needed - we keep the template HTML
		// Keeping function for backwards compatibility but it does nothing
		return;
	},

	showSuccess(message) {
		// Use theme alert system
		if (window.wpcore && window.wpcore.showAlert) {
			window.wpcore.showAlert('success', wpcore.direct_t({ en: 'Success!', fr: 'Succès !' }), message);
		} else {
			alert(message);
		}
	},

	showError(message) {
		// Use theme alert system
		if (window.wpcore && window.wpcore.showAlert) {
			window.wpcore.showAlert('error', wpcore.direct_t({ en: 'Error', fr: 'Erreur' }), message);
		} else {
			alert(message);
		}
	},
};

/**
 * Initialize DUO Code Apply
 */
export function initDuoCodeApply() {
	DuoCodeApply.init();
}
